module.exports = __webpack_public_path__ + "static/img/img25.97ad8c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img25.png
// module id = nUdT
// module chunks = 1